import { render } from "./indexUserComponent.vue?vue&type=template&id=28eb23f2"
import script from "./indexUserComponent.vue?vue&type=script&lang=js"
export * from "./indexUserComponent.vue?vue&type=script&lang=js"

import "./indexUserComponent.vue?vue&type=style&index=0&id=28eb23f2&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__